<template>
<div id="partners">
  <h2>Partners</h2>

  <partner-nav></partner-nav>

  <pagination
    :resourceUrl="this.apiUrl('/partners', true)"
    orderBy="name"
  >
    <template
      slot="paged_item"
      slot-scope="item"
    >
      <router-link
        :class="$root.listItemClasses"
        :to="{ name: 'partner', params: { partnerId: item.id }}"
      >
        {{ item.name }}
      </router-link>
    </template>
  </pagination>
</div>
</template>

<script>
import Pagination from 'sai-vue-kaminari'

import PartnerNav from '@/components/PartnerNav'

import PartnersStore from '@/stores/PartnersStore'

export default {
  data () {
    return PartnersStore.state
  },

  components: {
    'pagination': Pagination,
    'partner-nav': PartnerNav
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Partners.vue